'use client'
import ImageComponent from "@/components/ui/ImageComponent"
import RatingStar from "@/components/ui/RatingStar"
import { replaceTemplatePlaceholders } from "@/util/replaceTemplateText"
import { scrollToContent } from "@/util/ScrollToContent"
import { Button } from "@heroui/react"

interface IConcernBannerIndexProps {
    title: string,
    subtitle: string,
    rating: number,
    totalRatings:number,
    proceduresDone?: number,
    description: string,
    treatment_image:string,
    treatment_image_alt:string
    cityName?: string
}

const ConcernBannerIndex = ({title,subtitle,rating,description,treatment_image,treatment_image_alt,cityName=""}:IConcernBannerIndexProps) => {

    const titleText = replaceTemplatePlaceholders(title,title,cityName||'');
    const subtitleText = replaceTemplatePlaceholders(subtitle, title, cityName || '');
    const descriptionText = replaceTemplatePlaceholders(description, title, cityName || '');

    return (
        <div className="h-auto flex flex-col lg:flex-row justify-center items-center mx-auto gap-x-[100px] gap-y-5 w-full">
            <div className="rounded-3xl overflow-hidden w-full lg:w-1/2 2xl:max-w-2/3">
                <ImageComponent url={treatment_image||"/images/concerns/concern_banner.png"} img_title={treatment_image_alt||"concern_banner_image"} />
            </div>
            <div className="flex flex-col justify-center items-start gap-y-[45px] w-full lg:flex-1">
                <div className="space-y-4">
                    <h1 className="large_heading_text font-semibold! tracking-[-2.4px] text-center lg:text-start">
                        <span className="text-textf1">{titleText}</span><br />
                        <span className="text-silverBlue">{subtitleText}</span>
                    </h1>
                    <p className="text-textf2 text-base/[155%] md:text-lg/[155%] w-full lg:w-11/12 text-center lg:text-start">
                       {descriptionText}
                    </p>
                </div>

                <div className="flex justify-between items-center gap-1 md:gap-5 mx-auto lg:mx-0 flex-wrap md:flex-nowrap">
                    
                    {/* <Button onPress={()=>scrollToContent("#explore_prevention")} className="bg-[#F9F9F9] text-lightBrown rounded-full text-sm lg:text-[17.4px]/[27px] font-medium lg:py-7 lg:px-7">How it Works</Button> */}
                    <div className="w-fit">
                        <div className="mx-auto flex gap-1 items-center justify-start">
                            <div className="h-auto lg:h-10 w-4.5 lg:w-[33px]">
                                <ImageComponent url="/images/home_data/google_logo.svg" />
                            </div>

                            <div className="text-[#040404] text-lg lg:text-[24px]/[33.6px] font-semibold ml-2">
                                {rating || 0}
                            </div>

                            <div className="flex flex-col">
                                <RatingStar starColor="#FFC107" height="23px" width="21px" starCount={5} totalRating={rating || 0} />
                            </div>
                        </div>
                        <span className="text-textf1 text-sm lg:text-base/[25.6px] font-normal pl-3">
                            Google Ratings
                        </span>
                    </div>
                    <Button onPress={()=>scrollToContent("#package_section")} className="silverblue_btn rounded-full text-sm lg:text-[17.4px]/[27px] font-medium lg:py-7 px-4 lg:px-7">Explore Treatments</Button>
                </div>

                {/* <div className="flex items-center justify-center lg:justify-start gap-10 xl:gap-20 mx-auto lg:mx-0">
                    <div className="w-full">
                        <div className="mx-auto flex gap-1 items-center justify-start">
                            <div className="h-auto lg:h-10 w-4.5 lg:w-[33px]">
                                <ImageComponent url="/images/home_data/google_logo.svg" />
                            </div>

                            <div className="text-[#040404] text-lg lg:text-[24px]/[33.6px] font-semibold ml-2">
                                {rating || 0}
                            </div>

                            <div className="flex flex-col">
                                <RatingStar starColor="#FFC107" height="23px" width="21px" starCount={5} totalRating={rating || 0} />
                            </div>
                        </div>
                        <span className="text-textf1 text-xs lg:text-base/[25.6px] font-normal pl-3">
                            Google Ratings
                        </span>
                    </div>

                    <div className="border-l-1 border-[#C4C2C2] pl-[11px] w-full">
                        <div className="font-semibold text-2xl/[33.6px] text-textf1">{proceduresDone||0}+</div>
                        <div className="text-xs lg:text-base/[25.6px] text-textf1 font-normal">Procedures Done</div>
                    </div> 
                </div> */}
            </div>
        </div>
    )
}

export default ConcernBannerIndex